import React from "react";
import { Close, InfoOutlined } from "@mui/icons-material";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";

interface PopoutHeaderProps {
  onClose: () => void;
}

const PopoutHeader: React.FC<PopoutHeaderProps> = ({ onClose }) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="h6" fontWeight={700}>
          Preferencing options
        </Typography>
        <Tooltip
          title="Tip: shift-clicking will allow additional features to be added to the selection, or removed from the selection if already selected."
          PopperProps={{ disablePortal: true }}
        >
          <InfoOutlined color="primary" sx={{ width: 15 }} />
        </Tooltip>
      </Box>

      <IconButton size="small" onClick={onClose} aria-label="Close">
        <Close fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default PopoutHeader;
